import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $q, ModalService, ServiceRequestService, InsuranceSuiteMetadata) => {
    const ctrl = Object.create(BaseCtrl);
    ctrl.init = () => {
        $scope.invoices = [];
        /* $scope.resultsTruncated = false;
        $scope.maxAllowedInvoices = 50; // Default in CC, but can be changed by configuration*/
        $scope.invoiceStatuses = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestInvoiceStatus');
    };

    $scope.messagesPromise = ServiceRequestService.getInvoicesForSpecialist().then(
        (globalInvoices) => {
            $scope.invoices = globalInvoices;
            /* $scope.resultsTruncated = globalInvoices.truncated;
            $scope.maxAllowedInvoices = globalInvoices.maxAllowedInvoices;*/
        },
        (error) => {
            console.error('Error', error);
        }
    );

    ctrl.lookupInvoiceStatus = (status) => {
        return $scope.invoiceStatuses.getCode(status);
    };

    ctrl.withdrawInvoice = (invoice) => {
        const state = $state.get('withdrawInvoice');
        state.data.serviceRequestNumber = invoice.serviceRequestNumber;
        state.data.invoice = invoice;
        $state.transitionTo(state);
    };

    ctrl.goToInvoiceDetails = (invoice) => {
        const state = $state.get('invoiceDetails');
        state.data.serviceRequest = $scope.serviceRequest;
        state.data.invoice = invoice;
        $state.transitionTo(state);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$q', 'ModalService', 'servicerequest.ServiceRequestService', 'InsuranceSuiteMetadata'];

export default fn;
